import { createContext } from "react";

type ListenerFunc = (input: string) => void;

const context: {
    display: boolean;
    listener: ListenerFunc | null;
    content: string;
    show: (listener: ListenerFunc, content: string) => void;
    hide: () => void;
} = {
    display: false,
    listener: null,
    content: "",
    show: (listener: ListenerFunc, content: string) => {
        context.listener = listener;
        context.display = true;
        context.content = content;
    },
    hide: () => {
        context.listener = null;
        context.display = false;
    },
};

const KeyboardContext = createContext(context);

export { KeyboardContext };
